<template>
  <CustomDataTable :data="activeEvents" :rowClass="rowClassEvent" :columns="ACTIVE_EVENT_COLUMNS" :menuModel="menuModel"
    v-model:selectedRow="selectedActiveEvent" :filterDictionary="filterDictionary" paginator :rows="50"
    :scrollHeight="scrollHeight" sortField="date" />

  <Dialog v-model:visible="showConfirmSound" :style="{ width: '650px' }" modal @hide="textConfirmSound = ''">
    <template #header>
      <i class="pi pi-exclamation-circle mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
      <div class="col-10 p-text-bold text-center" style="font-size: 20px">
        Причина квитирование сигнала: <strong>{{ selectedActiveEvent.textForSoundReproduction }}</strong>
      </div>
    </template>
    <div v-if="confirmSoundLoading" class="text-center">
      <ProgressSpinner />
    </div>
    <div v-else class="text-center">
      <Textarea v-model="textConfirmSound" rows="3" cols="100" class="fixed-textarea" maxlength="150" />
    </div>
    <template #footer>
      <Button label="Отмена" icon="pi pi-times" class="p-button-text" @click="showConfirmSound = false" />
      <Button label="Сохранить" icon="pi pi-check" class="p-button-text" @click="fetchConfirmSound"
        :disabled="!textConfirmSound.length" />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';
import axios from 'axios';
import { ACTIVE_EVENT_COLUMNS, rowClassEvent, API_CONFIRM_SOUND } from './constants';
import { useActiveEvents } from './useActiveEvents';

const props = defineProps({
  scrollHeight: {
    default: null,
    type: String,
  },
  checkFacilityId: {
    default: false,
    type: Boolean,
  },
});

const store = useStore();
const toast = useToast();

const { activeEvents, filterDictionary, selectedActiveEvent } = useActiveEvents(props);
const confirmSoundLoading = ref(false);
const showConfirmSound = ref(false);
const textConfirmSound = ref('');

const menuModel = computed(() => [
  {
    label: 'Выключить оповещение',
    icon: 'pi pi-bell',
    command: () => {
      if (selectedActiveEvent.value?.shouldPlaySound) {
        showConfirmSound.value = true;
      } else {
        toast.add({
          severity: 'warn',
          summary: 'Оповещение отключено',
          detail: 'Звуковое оповещение не включено для данного события',
          life: 3000,
        });
      }
    },
  },
]);

const fetchConfirmSound = () => {
  const headers = {
    Authorization: 'Basic ' + btoa(store.getters.info.login + ':' + store.getters.password),
  };
  const apiConf = `${store.getters.server('TM_MIDDLE')}${API_CONFIRM_SOUND}`;
  confirmSoundLoading.value = true;
  axios
    .post(apiConf, { eventId: selectedActiveEvent.value.id, userId: store.getters.info.userId, confirmReason: textConfirmSound.value }, { headers })
    .then(() => {
        toast.add({
          severity: 'success',
          summary: 'Сигнал квитирован',
          detail: 'Событие успешно обработано и квитировано',
          life: 3000,
        });
    })
    .catch((er) => {
      store.commit('SET_ERROR', {
        er: er?.response ?? er,
        source: ['ActiveEvent', 'fetchConfirmSound'],
      });
    })
    .finally(() => {
      showConfirmSound.value = false;
      confirmSoundLoading.value = false;
    });
};

const onSelectRow = (row) => {
  selectedActiveEvent.value = row;
};
</script>


<style scoped lang="scss">
::v-deep(.row-accessories-blue) {
  background-color: rgba(57, 26, 196, 1) !important;
}

::v-deep(.row-accessories-green) {
  background-color: #c0dcc0 !important;
}

::v-deep(.row-accessories-red) {
  background-color: #ff6c6c !important;
}

::v-deep(.row-accessories-yellow) {
  background-color: #fcfa98 !important;
}

::v-deep(.row-accessories-orange) {
  background-color: #f8d69c !important;
}

::v-deep(.row-accessories-red_ligt) {
  background-color: #f58484 !important;
}
</style>
